/* ll-recipe-card.js
   Powers Volarre recipe cards placed inside blog article HTML (no inline JS needed).
*/
(function () {
  "use strict";

  function formatFraction(amount) {
    const decimal = Math.round(amount * 100) / 100;
    if (Number.isInteger(decimal)) return String(decimal);

    const whole = Math.floor(decimal);
    const fraction = decimal - whole;

    let fractionStr = "";
    if (Math.abs(fraction - 0.25) < 0.05) fractionStr = "¼";
    else if (Math.abs(fraction - 0.5) < 0.05) fractionStr = "½";
    else if (Math.abs(fraction - 0.75) < 0.05) fractionStr = "¾";
    else fractionStr = decimal.toFixed(1).replace(".0", "");

    return whole > 0 ? `${whole} ${fractionStr}` : fractionStr;
  }

  function findUnitEl(qtyEl) {
    // In your markup, .unit is the next element sibling of .qty in the same span line.
    const parent = qtyEl.parentElement;
    if (!parent) return null;
    return parent.querySelector(".unit");
  }

  function isNumericUnitText(text) {
    // e.g. "170g" "30ml"
    return /\d/.test(String(text || ""));
  }

  function metricNumberFrom(text) {
    const n = parseFloat(String(text || "").replace(/[^\d.]/g, ""));
    return Number.isFinite(n) ? n : null;
  }

  function metricSuffixFrom(text) {
    // "170g" -> "g", "30ml" -> "ml"
    const t = String(text || "");
    return isNumericUnitText(t) ? t.replace(/[0-9.\s]/g, "") : t;
  }

  function updateValues(card) {
    const baseYield = parseFloat(card.dataset.baseYield || "4");
    const currentYield = parseFloat(card.dataset.currentYield || card.dataset.baseYield || "4");
    const units = card.dataset.units || card.dataset.defaultUnits || "US";
    const ratio = currentYield / baseYield;

    // yield labels
    const yieldCount = card.querySelector(".js-yieldCount");
    if (yieldCount) yieldCount.textContent = String(currentYield);

    // stat yield (outside card but in same article container)
    const container = card.closest(".ll-article-container");
    const statYield = container ? container.querySelector(".js-stat-yield") : null;
    if (statYield) statYield.textContent = String(currentYield);

    // quantities
    const qtyEls = card.querySelectorAll(".qty");
    qtyEls.forEach((qtyEl) => {
      const base = parseFloat(qtyEl.getAttribute("data-base") || "0");
      const type = qtyEl.getAttribute("data-type") || "volume";
      const unitEl = findUnitEl(qtyEl);

      let displayQty = base * ratio;

      if (units === "Metric" && type !== "fixed" && unitEl) {
        const metricAttr = unitEl.getAttribute("data-unit-metric") || "";
        if (isNumericUnitText(metricAttr)) {
          const metricBase = metricNumberFrom(metricAttr);
          if (metricBase != null) displayQty = Math.round(metricBase * ratio);
        }
      }

      qtyEl.textContent = (units === "Metric" && type !== "fixed")
        ? String(displayQty)
        : formatFraction(displayQty);

      if (unitEl) {
        if (units === "US") {
          unitEl.textContent = unitEl.getAttribute("data-unit-us") || unitEl.textContent;
        } else {
          const m = unitEl.getAttribute("data-unit-metric") || unitEl.textContent;
          unitEl.textContent = metricSuffixFrom(m);
        }
      }
    });
  }

  function setUnits(card, units) {
    card.dataset.units = units;

    // toggle button state
    card.querySelectorAll(".js-units").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.units === units);
    });

    updateValues(card);
  }

  function updateYield(card, delta) {
    const current = parseFloat(card.dataset.currentYield || card.dataset.baseYield || "4");
    const next = current + delta;
    if (next < 1) return;

    card.dataset.currentYield = String(next);
    updateValues(card);
  }

  function printRecipe(card) {
    const clone = card.cloneNode(true);

    // remove interactive controls from print
    const controls = clone.querySelector(".recipe-controls");
    if (controls) controls.remove();
    const buttons = clone.querySelector(".button-container");
    if (buttons) buttons.remove();

    const w = window.open("", "_blank", "width=900,height=900");
    if (!w) return;

    w.document.write(`
      <html>
        <head>
          <title>Print Recipe</title>
          <meta charset="utf-8"/>
          <meta name="viewport" content="width=device-width, initial-scale=1"/>
          <style>
            body{font-family:Montserrat,Arial,sans-serif;padding:40px;color:#111}
            .recipe-card{border:2px solid #D0021B;padding:40px;max-width:650px;margin:0 auto;position:relative}
            h2{font-family:Playfair Display,serif;text-align:center;font-size:24pt;margin:0 0 20px}
            .card-logo{position:absolute;top:20px;right:20px;width:45px!important}
            .section-header{text-transform:uppercase;color:#D0021B;font-weight:700;border-bottom:1px solid #eee;margin-top:25px;padding-bottom:8px;letter-spacing:.12em;font-size:12px}
            ul,ol{line-height:1.6}
          </style>
        </head>
        <body>${clone.outerHTML}</body>
      </html>
    `);
    w.document.close();
    w.focus();
    w.print();
    w.close();
  }

  async function shareRecipe(card) {
    const container = card.closest(".ll-article-container");
    const titleEl = container ? container.querySelector("h1") : null;
    const title = titleEl ? titleEl.textContent.trim() : document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url: window.location.href });
      } catch (_) {}
      return;
    }

    // fallback copy
    const tmp = document.createElement("input");
    tmp.value = window.location.href;
    document.body.appendChild(tmp);
    tmp.select();
    document.execCommand("copy");
    document.body.removeChild(tmp);
    alert("Link copied.");
  }

  function initCard(card) {
    // set initial state
    if (!card.dataset.baseYield) card.dataset.baseYield = card.getAttribute("data-base-yield") || "4";
    if (!card.dataset.currentYield) card.dataset.currentYield = card.dataset.baseYield;
    if (!card.dataset.units) card.dataset.units = card.dataset.defaultUnits || card.getAttribute("data-default-units") || "US";

    updateValues(card);
    setUnits(card, card.dataset.units);
  }

  function initAll() {
    document.querySelectorAll(".js-recipe-card").forEach(initCard);
  }

  // Event delegation: survives theme re-renders
  document.addEventListener("click", (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    const card = t.closest(".js-recipe-card");
    if (!card) return;

    const yieldBtn = t.closest(".js-yield");
    if (yieldBtn) {
      e.preventDefault();
      updateYield(card, parseInt(yieldBtn.getAttribute("data-delta") || "0", 10));
      return;
    }

    const unitsBtn = t.closest(".js-units");
    if (unitsBtn) {
      e.preventDefault();
      setUnits(card, unitsBtn.getAttribute("data-units") || "US");
      return;
    }

    const printBtn = t.closest(".js-print");
    if (printBtn) {
      e.preventDefault();
      printRecipe(card);
      return;
    }

    const shareBtn = t.closest(".js-share");
    if (shareBtn) {
      e.preventDefault();
      shareRecipe(card);
      return;
    }
  });

  // init on load + Shopify section reloads
  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:theme:section:load", initAll);
})();